/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const slider = document.querySelector('.testimonials .splide');

if( slider ) {
    var splide = new Splide( '.testimonials .splide' , {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: false,
        pagination: false,
        perPage: 2.5,
        perMove: 1,
        start: 1,
        focus  : 'center',
        // padding: {
        //     right: '5%'
        // },
        // gap: '3%',
        breakpoints: {
            960: {
                perPage: 1,
                // padding: {
                //     right: '10%'
                // },
            },
        }
    });
    splide.mount();
}